import { InviteSuperAdminUserRequestSchema, InviteSuperAdminUserResponseSchema } from './invite-superadmin-user.schema';
/**
 * Invite SuperAdmin User Endpoint Contract
 * Creates a new superadmin user and sends invitation email
 */ export const inviteSuperAdminUserContract = {
    method: 'POST',
    path: '/api/v2/superadmin-users/invite',
    description: 'Create a new superadmin user and send invitation email',
    requestSchema: InviteSuperAdminUserRequestSchema,
    responseSchema: InviteSuperAdminUserResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad request - invalid user data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            409: 'Conflict - user with this email already exists'
        }
    }
};

//# sourceMappingURL=invite-superadmin-user.contract.js.map